// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"be52f9fa","567":"6c276176"}[chunkId] + ".chunk.js";
};